<template>
    <div class="ScenarioExampleTest">
        <!--Header-->
        <div class="display-flex align-center justify-space-between header-page">
            <div class="page-title">
                {{ $f.tc('autoTest') }}
            </div>
            <div class="centerY statistic">
                <!--Statistic-->
                <!--Success-->
                <strong class="statistic-number success-number">{{ testcasesStatistic.succeeded }}</strong>
                {{ $f.tc('success') }}
                <!--Fail-->
                <div class="px-10">-</div>
                <strong class="statistic-number fail-number">{{ testcasesStatistic.failed }}</strong>
                {{ $f.tc('fail') }}
                <!--Total-->
                <div class="px-10">/</div>
                <div class="statistic-number">{{ testcasesStatistic.total }}</div>
                <div class="total">Testcases</div>
                <div class="btn-outline-primary btn-run ml-20" @click="runAllTestSet">
                    <div class="icon-run mr-6"></div>
                    {{ $f.tc('runAll') }}
                </div>
            </div>
        </div>
        <div class="breadcrumbs-bar">
            <div class="display-flex align-center" style="color: #6a82a5;">
                <router-link class="no-underline" v-if="scenario" :to="`/scenarios/${scenario.id}`">
                    {{ scenario.name }}
                </router-link>
                <div class="px-2">/</div>
                <router-link class="no-underline" v-if="scenario" :to="`/scenarios/${scenario.id}/testsets`">
                    {{ $f.tc('autoTest') }}
                </router-link>
                <div class="px-2">/</div>
                <router-link class="no-underline" v-if="scenario"
                             :to="`/scenarios/${scenario.id}/testsets/${$route.params.groupName}`">
                    {{ $route.params.groupName }}
                </router-link>
            </div>
        </div>
        <!--Content page-->
        <v-layout>
            <!--List test set or testcases-->
            <div style="width: 24%; min-width: 420px" class="col-panel">
                <div class="fci-scrollbar" style="overflow-y: auto"
                     :style="{height: `${testcasesSelected.length > 0 ? 'calc(100% - 53px)' : '100%'}`}">
                    <div v-for="item in testSetList" :key="`test_set_${item.group.replaceAll(' ', '_')}`">
                        <!--List test set-->
                        <div
                            class="centerY test-set"
                            :class="[
                                item['group'] === testcaseActivated['group'] ? 'testset-actived' : '',
                                item.isEnable ? '' : 'item-disabled'
                            ]"
                            :style="{background: `${item.isCollapse ? '' : '#F7F9FD'}`}"
                        >
                            <div class="centerY">
                                <v-checkbox
                                    hide-details
                                    :indeterminate="item.isSelected"
                                    color="#66BB6A"
                                    v-model="item.isSelected"
                                    @change="(newVal) => checkTestcasesOfTestSet(item.group, newVal)"
                                ></v-checkbox>
                                <div class="label-checkbox mr-8" :title="item.group">{{ item.group }}</div>
                                <!--Icon for status-->
                                <img v-if="item.status === -1" src="/img/scenario/fail.svg" alt="icon-fail"
                                     style="transform: scale(1.13)">
                                <img v-if="item.status === 1" src="/img/scenario/success.svg" alt="icon-success"
                                     style="transform: scale(1.13)">
                            </div>
                            <v-spacer></v-spacer>
                            <div v-if="item.isEnable" class="btn-icon btn-run-testcase mr-6" @click="runTestSet(item)">
                                <img src="/img/scenario/play_grey.svg" alt="icon-run-testcase">
                            </div>
                            <img v-else class="mr-10" src="/img/scenario/play-disable.svg"
                                 alt="icon-run-testcase-disable" style="transform: scale(0.9);">
                            <div class="btn-icon" @click="item.isCollapse = !item.isCollapse">
                                <img
                                    src="/img/arrow-down.svg"
                                    alt="icon-collapse"
                                    style="width: 20px"
                                    :style="{transform: `${item.isCollapse ? '' : 'rotate(180deg)'}`}"
                                >
                            </div>
                        </div>
                        <!--List testcases-->
                        <v-expand-transition>
                            <div v-if="!item.isCollapse">
                                <div
                                    v-for="testcase in item.testcases" :key="testcase['test_id']"
                                    class="centerY testcase"
                                    :class="[
                                        testcase['test_id'] === testcaseActivated['test_id'] ? 'testcase-actived' : '',
                                        testcase['is_enable'] ? '' : 'item-disabled'
                                    ]"
                                    @click="activeTestcase(testcase)"
                                >
                                    <div class="centerY">
                                        <v-checkbox
                                            hide-details
                                            color="#66BB6A"
                                            v-model="testcase.isSelected"
                                        ></v-checkbox>
                                        <div class="label-checkbox mr-8" :title="testcase.name">{{
                                                testcase.name
                                            }}
                                        </div>
                                        <!--Icon for status-->
                                        <img v-if="testcase.status === -1" src="/img/scenario/fail.svg" alt="icon-fail"
                                             style="transform: scale(1.13)">
                                        <img v-if="testcase.status === 1" src="/img/scenario/success.svg"
                                             alt="icon-success" style="transform: scale(1.13)">
                                    </div>
                                    <v-spacer></v-spacer>
                                    <div v-if="testcase['is_enable']" class="btn-icon btn-run-testcase mr-6"
                                         @click="runTestcase(testcase)">
                                        <img src="/img/scenario/play_grey.svg" alt="icon-run-testcase">
                                    </div>
                                    <img v-else class="mr-10" src="/img/scenario/play-disable.svg"
                                         alt="icon-run-testcase-disable" style="transform: scale(0.9);">
                                    <div class="switch-text" @click.stop>
                                        <input type="checkbox" :id="testcase['test_id']"
                                               v-model="testcase['is_enable']"
                                               @input="onOrOffTestcase(testcase)"/><label
                                        :for="testcase['test_id']"></label>
                                    </div>
                                </div>
                            </div>
                        </v-expand-transition>
                    </div>
                </div>
                <v-fade-transition>
                    <div class="bar-btn-delete centerXY" v-if="testcasesSelected.length > 0">
                        <div class="btn-outline-danger" @click="deleteTestcasesSelected">
                            <img src="/img/delete-new-2.svg" alt="icon-delete-selected-testcases" class="mr-6">
                            {{ $f.tc('delete') }}
                        </div>
                    </div>
                </v-fade-transition>
            </div>
            <!--Test area-->
            <div style="flex: 1">
                <div class="d-flex test-area fci-scrollbar">
                    <!--TEST CASE-->
                    <div style="width: 50%">
                        <div class="title-col">{{ nameColTestcase }}</div>
                        <div class="message-container">
                            <div v-for="(step, i) in stepList" :key="i" class="mb-20">
                                <!--User message-->
                                <div v-if="step.type === NodeType.DECISION"
                                     class="display-flex align-start justify-end">
                                    <div class="message-wrap" style="align-items: flex-end;">
                                        <div
                                            class="message-content"
                                            :class="getMessageClass(step.type)"
                                            style="margin-bottom: 2px"
                                        >
                                            <template>{{ step.text }}</template>
                                        </div>
                                        <div class="more-info" style="text-align: right">
                                            <div v-if="step.slug" class="centerY">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on}">
                                                        <div v-on="on" style="cursor: pointer">
                                                            <b>{{ step.slug }}</b>
                                                        </div>
                                                    </template>
                                                    <span class="ml-3">{{ step['node_id'] }}</span>
                                                </v-tooltip>
                                            </div>
                                            <div v-else-if="step.node_id">{{ step.node_id }}</div>
                                            <div v-else>{{ $t('unknown') }}</div>
                                        </div>
                                    </div>
                                    <div class="message-icon ml-12" style="background: #E4EDFA">
                                        <!--<img :src="NodeIconMap[step.type]" alt="icon">-->
                                        <img src="/img/scenario/user.svg" alt="icon-user">
                                    </div>
                                </div>
                                <!--BOT message-->
                                <div v-else class="display-flex align-start justify-start">
                                    <div class="message-icon mr-12" style="background: #96ADD0">
                                        <div style="font-family: 'open sans semi',serif; color: #FFFFFF">BOT</div>
                                    </div>
                                    <div class="message-wrap">
                                        <div class="message-content" :class="getMessageClass(step.type)"
                                             style="margin-bottom: 2px" v-if="canPlayAudio(step.audio_link)">
                                            &lt;audio&gt;name="{{
                                                audioMap[step.audio_slug] ? audioMap[step.audio_slug].name : 'unknown'
                                            }}"&lt;/audio&gt;
                                        </div>
                                        <div v-else
                                             class="message-content"
                                             :class="getMessageClass(step.type)"
                                             style="margin-bottom: 2px"
                                        >
                                            <template>{{ step.text }}</template>
                                        </div>
                                        <div class="more-info">
                                            <div v-if="step.slug" class="centerY">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on}">
                                                        <div v-on="on" style="cursor: pointer">
                                                            <b>{{ step.slug }}</b>
                                                        </div>
                                                    </template>
                                                    <span class="ml-3">{{ step['node_id'] }}</span>
                                                </v-tooltip>
                                            </div>
                                            <div v-else-if="step.node_id">{{ step.node_id }}</div>
                                            <div v-else>{{ $t('unknown') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--TEST RESULT-->
                    <div style="width: 50%">
                        <div class="title-col">{{ $f.tc('resultTest') }}</div>
                        <v-layout justify-center align-center v-if="isRunningTestcase"
                                  style="height: calc(100vh - 246px);">
                            <v-progress-circular
                                indeterminate
                                width="3"
                                color="#0052CC"
                                style="width: 30px"
                            ></v-progress-circular>
                        </v-layout>
                        <div class="message-container" style="border-right: none" v-else>
                            <div v-for="(message, i) in messageList" :key="i" class="mb-20">
                                <!--User message-->
                                <div v-if="message.type === NodeType.DECISION"
                                     class="display-flex align-start justify-end">
                                    <div class="message-wrap" style="align-items: flex-end;">
                                        <div
                                            class="message-content"
                                            :class="getMessageClass(message.type)"
                                            style="margin-bottom: 2px"
                                        >
                                            <template>{{ message.text }}</template>
                                        </div>
                                        <div class="centerY more-info"
                                             style="text-align: right">
                                            <div
                                                v-if="message.status === -1"
                                                class="centerY"
                                                style="font-family: 'open sans semi',serif; color: #DE6F5F"
                                            >
                                                <img src="/img/scenario/fail.svg" class="mr-6" alt="icon-fail">
                                                {{ $f.tc('failed') }}
                                            </div>
                                            <div
                                                v-if="message.status === 0"
                                                class="centerY"
                                                style="font-family: 'open sans semi',serif; color: #ffad33"
                                            >
                                                <img src="/img/scenario/question.svg" class="mr-6" alt="icon-help">
                                                {{ $f.tc('unknown') }}
                                            </div>
                                            <div
                                                v-if="message.status === 1"
                                                class="centerY"
                                                style="font-family: 'open sans semi',serif; color: #66BB6A"
                                            >
                                                <img src="/img/scenario/success.svg" class="mr-6" alt="icon-success">
                                                {{ $f.tc('succeeded') }}
                                            </div>
                                            <v-icon color="#617CA5" style="width: 16px">mdi-circle-small</v-icon>
                                            <div v-if="message.node" class="centerY">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on}">
                                            <span v-on="on" style="cursor: pointer">
                                                <b>{{ message.node.slug }}</b>
                                            </span>
                                                    </template>
                                                    <span class="ml-3">{{ message.node.id }}</span>
                                                </v-tooltip>
                                            </div>
                                            <div v-else>{{ $t('unknown') }}</div>
                                        </div>
                                    </div>
                                    <div class="message-icon ml-12" style="background: #E4EDFA">
                                        <!--<img :src="NodeIconMap[step.type]" alt="icon">-->
                                        <img src="/img/scenario/user.svg" alt="icon-user">
                                    </div>
                                </div>
                                <!--BOT message-->
                                <div v-else class="display-flex align-start justify-start">
                                    <div class="message-icon mr-12" style="background: #96ADD0">
                                        <div style="font-family: 'open sans semi',serif; color: #FFFFFF">BOT</div>
                                    </div>
                                    <div class="message-wrap">
                                        <div class="message-content" :class="getMessageClass(message.type)"
                                             style="margin-bottom: 2px" v-if="canPlayAudio(message.audio_link)">
                                            &lt;audio&gt;name="{{
                                                audioMap[message.audio_slug] ? audioMap[message.audio_slug].name : 'unknown'
                                            }}"&lt;/audio&gt;
                                        </div>
                                        <div v-else
                                             class="message-content"
                                             :class="getMessageClass(message.type)"
                                             style="margin-bottom: 2px"
                                        >
                                            <template>{{ message.text }}</template>
                                        </div>
                                        <div class="centerY more-info">
                                            <div
                                                v-if="message.status === -1"
                                                class="centerY"
                                                style="font-family: 'open sans semi',serif; color: #DE6F5F"
                                            >
                                                <img src="/img/scenario/fail.svg" class="mr-6" alt="icon-fail"
                                                     style="transform: scale(1.13)">
                                                {{ $f.tc('failed') }}
                                            </div>
                                            <div
                                                v-if="message.status === 0"
                                                class="centerY"
                                                style="font-family: 'open sans semi',serif; color: #ffad33"
                                            >
                                                <img src="/img/scenario/question.svg" class="mr-6" alt="icon-help">
                                                {{ $f.tc('unknown') }}
                                            </div>
                                            <div
                                                v-if="message.status === 1"
                                                class="centerY"
                                                style="font-family: 'open sans semi',serif; color: #66BB6A"
                                            >
                                                <img src="/img/scenario/success.svg" class="mr-6" alt="icon-success"
                                                     style="transform: scale(1.13)">
                                                {{ $f.tc('succeeded') }}
                                            </div>
                                            <v-icon color="#617CA5" style="width: 16px">mdi-circle-small</v-icon>
                                            <div v-if="message.node" class="centerY" :title="message.node.id">
                                                <div v-if="message.node.slug">
                                                    <strong class="ellipsis-text">{{ message.node.slug }}</strong>
                                                </div>
                                                <div v-else>{{ message.node.id }}</div>
                                            </div>
                                            <div v-else>{{ $t('unknown') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bar-action-test centerXY">
                    <div class="btn-outline-primary btn-compare" v-if="messageList.length > 0"
                         @click="openDialogCompareDataCollection">
                        <div class="icon-compare"></div>
                        {{ $f.tc('compareDataCollection') }}
                    </div>
                    <div class="btn-primary-disable btn-compare" v-else>
                        <div class="icon-compare"></div>
                        {{ $f.tc('compareDataCollection') }}
                    </div>
                    <CompareDataCollectionDialog ref="CompareDataCollectionDialog"
                                                 :testcase-old="testcaseActivated"
                                                 :data-collection-list-new="dataCollectionList"></CompareDataCollectionDialog>
                    <div class="btn-outline-primary btn-overwrite" v-if="messageList.length > 0"
                         @click="overwriteTestcase">
                        <div class="icon-overwrite"></div>
                        {{ $f.tc('overwriteTestcase') }}
                    </div>
                    <div class="btn-primary-disable btn-overwrite" v-else>
                        <div class="icon-overwrite"></div>
                        {{ $f.tc('overwriteTestcase') }}
                    </div>
                </div>
            </div>
        </v-layout>
    </div>
</template>

<script>
import ScenarioService from '@/services/scenario.service'
import $const from '@/utils/const'
import CompareDataCollectionDialog from '@/views/Scenario/example/CompareDataCollectionDialog'
import { mapState } from 'vuex'

const { NodeType, NodeIconMap } = ScenarioService

export default {
    name: 'ScenarioAutomationTest',
    components: { CompareDataCollectionDialog },
    data () {
        return {
            NodeType, NodeIconMap,
            scenario: null,
            nodeList: [],
            nodeMap: {},
            testSetList: [],
            testcasesSelected: [],
            stepList: [],
            messageList: [],
            testResult: {},
            isRunningTestcase: false,
            testcaseActivated: null,
            nameColTestcase: 'Testcase',
            nextTestStepIndex: 0,
            testcasesRunning: [],
            testcaseRunningIndex: 0,
            testcasesStatistic: {
                total: 0,
                succeeded: 0,
                failed: 0
            },
            dataCollectionList: {},
            variableList: [],
            audioMap: {},
            userAttributes: {},
        }
    },
    mounted () {
        this.getData()
        this.audioListMap(this.audioList)
    },
    computed: {
        ...mapState({
            audioList: state => state.scenario.scenarioAudioList,
        })
    },
    methods: {
        // map audio link to name
        audioListMap (audioList) {
            audioList.forEach(audio => {
                this.audioMap[audio.slug] = audio
            })
        },
        // functions call api get data
        getData () {
            let scenarioId = this.$route.params.scenarioId
            if (!scenarioId) {
                this.$appService.toastError('Can\'t get scenario ID')
                return
            }
            this.$appService.showLoading()
            Promise.all([
                this.getScenario(scenarioId),
                this.getTestcases(scenarioId),
                this.getNodes(scenarioId),
                this.getVariables(scenarioId)
            ]).finally(this.$appService.hideLoading)
        },
        getVariables (scenarioId) {
            return ScenarioService.VariableService.search(scenarioId).then(
                result => {
                    this.variableList = result.data
                }
            )
        },
        getScenario (scenarioId) {
            return ScenarioService.read(scenarioId).then(
                result => {
                    this.scenario = result.data
                }
            )
        },
        getTestcases (scenarioId) {
            let groupName = this.$route.params.groupName
            if (groupName !== $const.RUN_ALL_TESTCASES) {
                return ScenarioService.getTestSet(scenarioId, groupName).then(result => {
                        this.updateTestSetList(result.data)
                    },
                    this.$appService.handleRequestError()
                )
            } else {
                return ScenarioService.AutomationTestService.search(scenarioId).then(result => {
                        this.updateTestSetList(result.data)
                    },
                    this.$appService.handleRequestError()
                )
            }
        },
        updateTestSetList (data) {
            let items = []
            data.forEach(item => {
                if (!items.find(i => i.group === item.group)) {
                    items.push({
                        isCollapse: true,
                        isSelected: false,
                        isEnable: true,
                        group: item.group,
                        status: 0,
                        testcases: data.filter(i => i.group === item.group).map(testcase => ({
                            ...testcase,
                            status: 0,
                            isSelected: false
                        })),
                        dataCollection: item['data_collection']
                    })
                }
            })
            this.testSetList = items
            if (this.testSetList[0]) {
                this.testSetList[0].isCollapse = false
                //active the first testcase
                this.activeTestcase(this.testSetList[0].testcases[0])
            }
        },
        getNodes (scenarioId) {
            return ScenarioService.NodeService.search(scenarioId, { page: 1, rowsPerPage: 500 }).then(
                result => {
                    let nodeList = result.data.data
                    let nodeMap = {}
                    for (let node of nodeList) {
                        nodeMap[node.id] = node
                    }
                    this.nodeList = nodeList
                    this.nodeMap = nodeMap
                }
            )
        },
        // functions handle run test
        activeTestcase (testcase) {
            this.testcaseActivated = testcase
            this.stepList = testcase.steps ? testcase.steps : []
            // update name testcase
            this.nameColTestcase = testcase.name ? testcase.name : 'Testcase'
            // update message list by test result (if any)
            this.messageList = this.testResult[testcase['test_id']] ? this.testResult[testcase['test_id']] : []
        },
        runAllTestSet () {
            this.testcasesRunning = this.testSetList.map(i => i.testcases).flat(1).filter(i => i['is_enable'])
            this.testcaseRunningIndex = 0
            this.runTestcase(this.testcasesRunning[0])
        },
        runTestSet (testSet) {
            this.testcasesRunning = testSet.testcases ? testSet.testcases.filter(i => i['is_enable']) : []
            this.testcaseRunningIndex = 0
            this.runTestcase(this.testcasesRunning[0])
        },
        runTestcase (testcase) {
            let callId = this.$store.state.user.profile.email + '-' + (new Date().getTime()) + '-' + Math.random()
            this.isRunningTestcase = true
            // reset
            this.nextTestStepIndex = 0
            this.messageList = []
            this.stepList = testcase.steps ? testcase.steps : []
            this.testcaseActivated = testcase
            this.testResult[testcase['test_id']] = []
            // send message
            this.sendMessage($const.MessageTypes.START, callId, testcase, 0)
        },
        sendMessage (message, callId, testcase, i) {
            let parameterList = testcase['customer_properties']
            let userAttributesInput = testcase['steps'][i]['user_attributes'] ? testcase['steps'][i]['user_attributes'] : {}
            i = i + 1
            if (message !== $const.MessageTypes.START && message !== $const.MessageTypes.GET_MORE_PROMPT) {
                this.messageList.push({
                    type: NodeType.DECISION,
                    status: 0,
                    text: message,
                    user_attributes: userAttributesInput
                })
            }
            return ScenarioService.sendMessage(
                this.$route.params.scenarioId,
                callId,
                message,
                parameterList,
                userAttributesInput
            ).then(
                result => {
                    let action = result.data
                    this.messageList.push({
                        type: NodeType.PROCESS,
                        status: 0,
                        text: action.prompt,
                        error: '',
                        audio_link: action['audio_link'] ? action['audio_link'] : '',
                        audio_slug: action['audio_slug'] ? action['audio_slug'] : '',
                    })
                    if (!action.test) {
                        this.$appService.toastError('No debug found')
                    }
                    if (action.test['user_attributes']) {
                        this.userAttributes = action.test['user_attributes']
                    }
                    let shouldContinue = true
                    let currentMessage = this.messageList[this.nextTestStepIndex]

                    // START LOGIC CHECK
                    if (this.nextTestStepIndex > 0) {
                        let previousStep = this.stepList[this.nextTestStepIndex - 1]
                        let previousMessage = this.messageList[this.nextTestStepIndex - 1]
                        if (previousStep['slug'] && action.test['decision_slug']) {
                            // chua check truong hop reprompt
                            if (previousStep['slug'] === action.test['decision_slug']) {
                                previousMessage.status = 1
                            } else {
                                previousMessage.status = -1
                                currentMessage.error = `${previousStep.node_id} !== ${action.test['decision_id']}`
                                shouldContinue = false
                                this.$appService.toastError('Wrong condition')
                                this.markTestcaseStatus(testcase, -1, this.userAttributes)
                            }
                            previousMessage.node = this.nodeMap[action.test['decision_id']]
                        } else {
                            previousMessage.status = 1
                        }
                    }
                    if (!shouldContinue) {
                        this.isRunningTestcase = false
                        return
                    }
                    if (action.test['go_to_node_slug'] === this.stepList[this.nextTestStepIndex]['slug']) {
                        if (this.stepList[this.nextTestStepIndex]['re_prompt_name']) {
                            if (this.stepList[this.nextTestStepIndex]['re_prompt_name'] === action.test['user_attributes']['{{re_prompt_name}}']) {
                                console.log(this.stepList[this.nextTestStepIndex]['re_prompt_name'])
                            }
                        }
                        currentMessage.status = 1
                        currentMessage.node = this.nodeMap[action.test['go_to_node_id']]
                        this.nextTestStepIndex++
                        if (this.nextTestStepIndex < this.stepList.length) {
                            let message = this.stepList[this.nextTestStepIndex].text
                            if (action['next_action']['type'] === 'get_more_prompt') {
                                message = $const.MessageTypes.GET_MORE_PROMPT
                            } else {
                                this.nextTestStepIndex++
                            }
                            this.sendMessage(message, callId, testcase, i)
                        } else {
                            this.isRunningTestcase = false
                            this.$appService.toastSuccess('Test successful')
                            this.markTestcaseStatus(testcase, 1, this.userAttributes)
                        }
                    } else {
                        currentMessage.status = -1
                        currentMessage.node = this.nodeMap[action.test['go_to_node_id']]
                        this.isRunningTestcase = false
                        currentMessage.error = `${action.test['go_to_node_slug']} !== ${this.stepList[this.nextTestStepIndex]['slug']}`
                        this.$appService.toastError('Wrong bot answer')
                        this.markTestcaseStatus(testcase, -1, this.userAttributes)
                    }
                    this.$forceUpdate()
                    // END LOGIC CHECK
                }
            )
        },
        markTestcaseStatus (testcase, status, userAttributes) {
            // get data_collection check save
            let dataCollection = {}
            let variablesSaved = this.variableList.filter(i => i['should_save']).map(i => i.name)
            if (userAttributes && variablesSaved.length > 0) {
                variablesSaved.forEach(variable => {
                    dataCollection[variable] = userAttributes[`{{${variable}}}`] ? userAttributes[`{{${variable}}}`] : ''
                })
            }
            this.dataCollectionList[testcase['test_id']] = dataCollection

            let testSet = this.testSetList.find(i => i.group === testcase.group)
            if (!testSet) {
                return
            }
            let testcaseNeedMark = testSet.testcases.find(i => i['test_id'] === testcase['test_id'])
            if (!testcaseNeedMark) {
                return
            }
            testcaseNeedMark.status = status
            // save result test
            this.testResult[testcase['test_id']] = this.messageList
            // run testcase next
            if (this.testcaseRunningIndex < this.testcasesRunning.length - 1) {
                this.testcaseRunningIndex++
                this.runTestcase(this.testcasesRunning[this.testcaseRunningIndex])
            }
            if (this.testcaseRunningIndex === this.testcasesRunning.length - 1) {
                // reset
                this.testcaseRunningIndex = 0
                this.testcasesRunning = []
            }
            // update status test set
            this.markTestSetStatus(testSet)
            this.$forceUpdate()
        },
        markTestSetStatus (testSet) {
            if (testSet.testcases.find(i => i.status === -1)) {
                testSet.status = -1
            } else if (testSet.testcases.find(i => i.status === 1)) {
                testSet.status = 1
            } else {
                testSet.status = 0
            }
        },
        // functions handle for checkbox
        checkTestcasesOfTestSet (group, val) {
            let testSet = this.testSetList.find(i => i.group === group)
            testSet.testcases.forEach(item => {
                item.isSelected = val
            })
        },
        onOrOffTestcase (testcase) {
            let scenarioId = this.$route.params.scenarioId
            if (!scenarioId) {
                this.$appService.toastError('Can\'t get scenario ID')
                return
            }
            testcase.status = (testcase.status === 1 || testcase.status === -1) ? 0 : testcase.status
            let testSet = this.testSetList.find(i => i.group === testcase.group)
            this.markTestSetStatus(testSet)
            // call api update status testcase
            ScenarioService.AutomationTestService.update(scenarioId, testcase['test_id'], {
                is_enable: !testcase['is_enable'] // Lấy "!" do khi gọi API trường is_enable chưa nhận được thay đổi mới
            }).then(() => {
                this.$appService.toastSuccess(this.$f.tc('overwriteTestcase') + ' ' + this.$t('successful'))
            })
        },
        // other functions
        getMessageClass (type) {
            return type ? (type === NodeType.PROCESS || type === NodeType.SUPPORTER ? 'bot' : 'user') : ''
        },
        overwriteTestcase () {
            this.$appService.confirm(
                this.$f.tc('confirmOverwriteTestcase'), this.$f.tc('actionUndone')).then(confirm => {
                    if (!confirm) {
                        return
                    }
                    let newStepsList = this.messageList.map(i => ({
                        node_id: i.node ? i.node.id : '',
                        slug: i.node ? i.node['slug'] : '',
                        text: i.text,
                        type: i.type,
                        user_attributes: i.user_attributes ? i.user_attributes : {},
                        audio_link: i.audio_link ? i.audio_link : '',
                        audio_slug: i.audio_slug ? i.audio_slug : '',
                    }))
                    let scenarioId = this.$route.params.scenarioId
                    if (!scenarioId) {
                        this.$appService.toastError('Can\'t get scenario ID')
                        return
                    }
                    ScenarioService.AutomationTestService.update(scenarioId, this.testcaseActivated['test_id'], {
                        steps: newStepsList,
                        data_collection: this.dataCollectionList[this.testcaseActivated['test_id']]
                    }).then(() => {
                        this.stepList = newStepsList
                        let testSet = this.testSetList.find(i => i.group === this.testcaseActivated.group)
                        let testcase = testSet.testcases.find(i => i['test_id'] === this.testcaseActivated['test_id'])
                        testcase.steps = newStepsList
                        this.$appService.toastSuccess(this.$f.tc('overwriteTestcase') + ' ' + this.$t('successful'))
                    }).then(() => {
                        this.getTestcases(scenarioId)
                    })
                }
            )
        },
        deleteTestcasesSelected () {
            this.$appService.confirm(
                this.$f.tc('confirmDeleteItemSelected', { item: 'testcase' }), this.$f.tc('actionUndone')).then(confirm => {
                    if (!confirm) {
                        return
                    }
                    let scenarioId = this.$route.params.scenarioId
                    if (!scenarioId) {
                        this.$appService.toastError('Can\'t get scenario ID')
                        return
                    }
                    // call api delete list testcases
                    const promises = []
                    this.testcasesSelected.forEach(testcase => {
                        promises.push(ScenarioService.AutomationTestService.delete(scenarioId, testcase['test_id']))
                    })
                    this.$appService.showLoading()
                    Promise.allSettled(promises).then(results => {
                        let isDeleteSuccess = true
                        results.forEach((result, i) => {
                            let testcaseDeleted = this.testcasesSelected[i]
                            if (result.status === 'fulfilled') {
                                // delete testcase in list test set
                                let testSetIdx = this.testSetList.findIndex(item => item.group === this.testcasesSelected[i].group)
                                let indexDeleted = this.testSetList[testSetIdx].testcases.findIndex(item => item['test_id'] === this.testcasesSelected[i]['test_id'])
                                this.testSetList[testSetIdx].testcases.splice(indexDeleted, 1)
                                if (this.testSetList[testSetIdx].testcases.length === 0) {
                                    this.testSetList.splice(testSetIdx, 1)
                                }
                            } else {
                                isDeleteSuccess = false
                                this.$appService.toastError(
                                    `${this.$f.tc('delete')} testcase \"${testcaseDeleted.name}\" ${this.$t('failed')}`
                                )
                            }
                        })
                        if (isDeleteSuccess) {
                            this.$appService.toastSuccess(`${this.$f.tc('delete')} testcases ${this.$t('successful')}`)
                        }
                        this.$appService.hideLoading()
                        // check delete all
                        if (this.testSetList.length === 0) {
                            return this.$router.push(`/scenarios/${scenarioId}/testsets`)
                        }
                        // update testcase actived
                        if (this.testcasesSelected.find(i => i['test_id'] === this.testcaseActivated['test_id'])) {
                            this.testcaseActivated = this.testSetList[0].testcases[0]
                        }
                        this.testcasesSelected = []
                    })
                }
            )
        },
        openDialogCompareDataCollection () {
            this.$refs.CompareDataCollectionDialog.open()
        },
        validURL (str) {
            let pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator
            return !!pattern.test(str)
        },
        canPlayAudio (audioLink) {
            if (this.validURL(audioLink)) {
                let ext = audioLink.split(/[#?]/)[0].split('.').pop().trim()
                if (ext === 'wav' || ext === 'mp3') {
                    return true
                }
            }
            return false
        }
    },
    watch: {
        testSetList: {
            deep: true,
            handler: function () {
                let testcases = this.testSetList.map(i => i.testcases).flat(1)
                // update testcase status statistics
                let testcasesSucceeded = testcases.filter(i => i.status === 1)
                let testcasesFailed = testcases.filter(i => i.status === -1)
                this.testcasesStatistic.total = testcases.length > 0 ? testcases.length : 0
                this.testcasesStatistic.succeeded = testcasesSucceeded.length > 0 ? testcasesSucceeded.length : 0
                this.testcasesStatistic.failed = testcasesFailed.length > 0 ? testcasesFailed.length : 0
                // update list testcases selected
                let selectedList = []
                testcases.forEach(i => {
                    if (i.isSelected) {
                        selectedList.push(i)
                    }
                })
                this.testcasesSelected = selectedList
                // update enable/disable test set
                this.testSetList.forEach(i => {
                    let checkNotEnable = !i.testcases.find(item => item['is_enable'])
                    i.isEnable = i.isEnable === !checkNotEnable ? i.isEnable : !checkNotEnable
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">
.header-page {
    background: #FFFFFF;
    border-bottom: 1px solid #E4EDFA;
    padding: 0 20px;
    flex-wrap: wrap;
    height: 63px;
    font-family: "open sans", serif;
    font-size: 14px;

    .page-title {
        font-family: "open sans bold", serif;
        font-size: 22px;
    }

    .btn-run:hover {
        .icon-run {
            transform: scale(1.15);
        }

        .icon-run:before {
            content: url("/img/scenario/run-test_white.svg") !important;
        }
    }

    .icon-run {
        height: 30px;
        transform: scale(1.05);
        transition: 0.4s ease-in-out;

        &:before {
            content: url("/img/scenario/run-test.svg");
        }
    }

    .statistic {
        color: #617CA5;
        cursor: default;

        .success-number {
            color: #66BB6A;
        }

        .fail-number {
            color: #DE6F5F;
        }

        .total {
            height: 36px;
            line-height: 36px;
            padding-right: 20px;
            border-right: 1px solid #E4EDFA;
        }
    }
}

.statistic-number {
    font-family: "open sans bold", serif;
    font-size: 20px;
    margin-right: 4px;
}

.breadcrumbs-bar {
    padding: 0 20px;
    height: 44px;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    border-bottom: 1px solid #E4EDFA;
    font-family: "open sans semi", serif;
    font-size: 16px;
}

.test-area {
    height: calc(100vh - 219px);
    overflow-y: auto;
    background: #FFFFFF;
}

.col-panel, .message-container {
    background: #FFFFFF;
    font-family: "open sans", serif;
    font-size: 14px;
}

.col-panel {
    border-right: 1px solid #E4EDFA;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.title-col {
    background: #F7F9FD;
    border-right: 1px solid #E4EDFA;
    border-bottom: 1px solid #E4EDFA;
    height: 27px;
    font-family: "open sans semi", serif;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #617CA5;
    position: sticky;
    top: 0;
}

.message-container {
    min-height: calc(100vh - 246px);
    padding: 16px;
    font-family: "open sans", serif;
    border-right: 1px solid #E4EDFA;
    font-size: 14px;

    .message-content {
        padding: 10px;
        border-radius: 5px;
        color: #fff;
        display: flex;
        align-items: center;
        line-height: 19px;
        min-height: 39px;

        &.bot {
            background: #0052CC;
        }

        &.user {
            background: #96ADD0;
        }
    }

    .message-icon {
        height: 51px;
        width: 51px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.test-set, .testcase {
    height: 44px;
    padding: 12px;
    border-bottom: 1px solid #E4EDFA;

    .btn-run-testcase {
        img {
            transform: scale(0.9);
            transition: 0.4s ease-in-out;
        }

        &:hover {
            img {
                transform: scale(1.05);
            }

        }
    }

    ::v-deep {
        .v-icon {
            font-size: 25px !important;
        }
    }
}

.testcase {
    padding-left: 30px !important;
    background: #F7F9FD;
}

.message-wrap {
    max-width: 82%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.more-info {
    height: 24px;
    line-height: 24px;
    cursor: default;
    color: #617CA5;
    font-size: 13px;
}

.item-disabled {
    color: #96ADD0 !important;
    opacity: 0.9;

    ::v-deep {
        .v-label, .v-icon {
            color: #96ADD0 !important;
        }
    }
}

.testset-actived {
    color: #0052cc;
    font-family: "open sans semi", serif;
}

.testcase-actived {
    color: #0052cc;
    background: #e4edfa !important;
}

.label-checkbox, .ellipsis-text {
    cursor: default;
    max-width: 220px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.ellipsis-text {
    max-width: 300px;
}

.bar-btn-delete {
    height: 52px;
    border-top: 1px solid #E4EDFA;
}

.bar-action-test {
    height: 52px;
    border-top: 1px solid #E4EDFA;
    background: #FFFFFF;

    .btn-overwrite:not(.btn-primary-disable):hover {
        .icon-overwrite {
            transform: scale(1.2);
        }

        .icon-overwrite:before {
            content: url("/img/copy-1_white.svg");
        }
    }

    .btn-compare {
        margin-right: 10px;
    }

    .btn-compare:not(.btn-primary-disable):hover {

        .icon-compare {
            transform: scale(1.2);
        }

        .icon-compare:before {
            content: url("/img/compare-white.svg");
        }
    }

    .icon-overwrite {
        line-height: 0;
        transform: scale(1.1);
        margin-right: 6px;
        transition: 0.4s ease-in-out;
    }

    .icon-compare {
        line-height: 0;
        transform: scale(1.1);
        margin-right: 6px;
        transition: 0.4s ease-in-out;
    }

    .btn-primary-disable {
        .icon-overwrite:before {
            content: url("/img/copy-1_grey.svg");
        }

        .icon-compare:before {
            content: url("/img/compare-grey.svg");
        }
    }

    .icon-overwrite:before {
        content: url("/img/copy-1.svg");
    }

    .icon-compare:before {
        content: url("/img/compare.svg");
    }
}

.example-item {
    padding: 5px;
    cursor: pointer;

    &:hover {
        background: #ccc;
    }

    &.active {
        background: #c6c6c6;
    }
}

.pl-62 {
    padding-left: 62px;
}

.pr-62 {
    padding-right: 62px;
}

::v-deep {
    .v-input--selection-controls {
        margin-top: 1px !important;
        padding-top: 0 !important;

        .v-label {
            font-family: "open sans", serif !important;
            font-size: 14px !important;
            color: #262626 !important;
            display: inline-block;
            max-width: 235px;
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
        }
    }

    .v-input--selection-controls__ripple {
        display: none;
    }

    a {
        color: #6a82a5;
        transition: 0.4s;

        &:hover {
            color: #0052cc;
        }
    }
}
</style>
